'use client';

import { cn } from '@/lib/cn';
import { getProductImage } from '@/lib/utils';

/**
 * Blur overlay component used to blur the background behind modals.
 */
export function ModalBlurOverlay() {
  return (
    <div className={cn('absolute left-0 top-0 z-10 h-dvh w-dvw', getProductImage())} />
  );
}
